// Stan pulpitu termometru T-4 z widoku bramy (WidokTermometrT4 - typy z Go). Worker podaje gotowe pola: temperatury
// (888.88 = null + `no_sensor`), alarm progu z flagi firmware (T4-4), moce znamionowe od klienta i łączną moc (T4-5);
// APP tylko wyświetla. Kanały i nazwy domyślne - z opisu linii w Go (KANALY_TERMOMETRT4).
import type { DeviceOut } from "../../gen/kontrakt";
import type { NastawyTermometrT4, PolaTermometrT4, WidokTermometrT4 } from "../../gen/linie/termometr-t4";
import { KANALY_TERMOMETRT4, KOMENDY_TERMOMETRT4, SPRZET_TERMOMETRT4 } from "../../gen/linie/termometr-t4";
import { jestOnline } from "../../ekrany/urzadzenia/obecnosc";
import { t } from "../../i18n/t";
import { liczba } from "../../uklad/format";
import type { OdczytListy } from "../lista";

export const KOMENDY = KOMENDY_TERMOMETRT4;

/** Dwa odczyty na karcie w Urządzeniach (WYGLAD.md #66): kanały 1 i 2 z nazwami klienta. */
export function odczytyListy(d: DeviceOut): OdczytListy[] {
  const w = stan(d).w;
  return KANALY.slice(0, 2).map((k) => ({ etykieta: nazwaKanalu(w, k),
    wartosc: bezCzujnika(w, k) ? t("Brak czujnika") : liczba(w?.fields[k.temp] as number | null | undefined, 1) + " °C" }));
}
export const SPRZET = SPRZET_TERMOMETRT4;
export const CZAS_S = KOMENDY.czas_potwierdzenia_s;

/** Kanał termometru: pole temperatury i alarmu w widoku, nastawy (komendy bramy), numer kanału wykresu. */
export interface Kanal {
  idx: number;
  domyslna: string;
  temp: keyof PolaTermometrT4;
  alarm: keyof PolaTermometrT4;
  nazwa: keyof NastawyTermometrT4 & string;
  prog: keyof NastawyTermometrT4 & string;
  typ: keyof NastawyTermometrT4 & string;
  kor: keyof NastawyTermometrT4 & string;
}

// Sufiksy tematów firmware w kolejności kanałów wykresu (lines/termometrt4 `channels`).
const SUFIKSY = ["10p", "Zbiornik", "UFO", "Bufor"] as const;

export const KANALY: Kanal[] = KANALY_TERMOMETRT4.map((k, i) => {
  const s = SUFIKSY[i] ?? "10p";
  const n = (i + 1) as 1 | 2 | 3 | 4;
  return {
    idx: k.idx, domyslna: k.nazwa, temp: `ch${n}`, alarm: `ch${n}_alarm`,
    nazwa: `nazwa${s}SET`, prog: `SETalarm${s}`, typ: `alarm${s}Typ`, kor: `kor${s}`,
  };
});

export interface Stan {
  w: WidokTermometrT4 | null;
  online: boolean;
  /** Konto może sterować (rola z bramy) i sztuka jest online. */
  steruje: boolean;
}

export function stan(d: DeviceOut): Stan {
  const w = d.widok?.type === "termometr-t4" ? (d.widok as unknown as WidokTermometrT4) : null;
  const online = jestOnline(w?.presence.status);
  return { w, online, steruje: online && d.mozna.includes("sterowanie") };
}

/** Nazwa kanału jak na termometrze: nadana przez klienta, inaczej domyślna; wielkie litery (stara karta). */
export function nazwaKanalu(w: WidokTermometrT4 | null, k: Kanal): string {
  const n = w?.settings?.[k.nazwa];
  return (typeof n === "string" && n.trim() ? n.trim() : k.domyslna).toUpperCase();
}

/** Brak czujnika w kanale (888.88 z firmware - lista `no_sensor` widoku). */
export function bezCzujnika(w: WidokTermometrT4 | null, k: Kanal): boolean {
  return w?.no_sensor?.includes(k.temp) ?? false;
}
